import React from 'react';
import PropTypes from 'prop-types';
import of from 'await-of';
import { connect as reduxConnect } from 'react-redux';
import { actions } from '#redux/reducers';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons';
import { roAPI } from '#utils/axiosAPI';
import styles from './formRegister.module.css';
import { Input } from '../../UI/input/input';
import { Controller, useForm } from 'react-hook-form';
import { Field, FieldError, FieldLabel } from '../../UI/form/form';


const FormRegister = ({ onAfterSubmit, alert }) => {
  const [terminos, setTerminos] = React.useState(false);
  const toggleTerminos = () => setTerminos(prevState => !prevState);
  const form = useForm({
    defaultValues: {
      name: '',
      last_name: '',
      email: '',
      password: '',
      password2: '',
    },
    mode: 'onChange',
  });

  const handleFormSubmit = async (data) => {
    
    const [, error] = await of(
      roAPI.post('/auth/register', {
        email: data.email,
        password: data.password,
        name: data.name,
        last_name: data.last_name,
      }),
    );
    if (!error) {
      onAfterSubmit('/auth/inicio', 'redirect');
      alert({
        type: 'success',
        title: '¡Estas a un solo paso!',
        message:
          'Antes de iniciar sesión es necesario que verifiques tu correo. Por favor revisa tu bandeja de entrada.',
      });
    }
  };

  return (
    <div data-testid="FormLogin">
      <form className={styles.form} onSubmit={form.handleSubmit(handleFormSubmit)} id="formLogin">
        <div className={styles['field-group']}>
          <Controller
            control={form.control}
            name="name"
            rules={{
              required: {
                value: true,
                message: 'El nombre es obligatorio.',
              },
            }}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid}>
                <FieldLabel data-invalid={fieldState.invalid} htmlFor="name">
                  Nombre
                </FieldLabel>
                <Input {...field} id="name" aria-invalid={fieldState.invalid} placeholder="Nombre" autoComplete="given-name" />
                {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
              </Field>
            )}
          />

          <Controller
            control={form.control}
            name="last_name"
            rules={{
              required: {
                value: true,
                message: 'Los apellidos son obligatorios.',
              },
            }}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid}>
                <FieldLabel data-invalid={fieldState.invalid} htmlFor="last_name">
                  Apellidos
                </FieldLabel>
                <Input {...field} id="last_name" aria-invalid={fieldState.invalid} placeholder="Apellidos" autoComplete="family-name" />
                {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
              </Field>
            )}
          />

          <Controller
            control={form.control}
            name="email"
            rules={{
              required: {
                value: true,
                message: 'El correo electrónico es obligatorio.',
              },
              pattern: { value: /^\S+@\S+$/i, message: 'El correo electrónico es inválido.' },
            }}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid}>
                <FieldLabel data-invalid={fieldState.invalid} htmlFor="email">
                  Correo electrónico
                </FieldLabel>
                <Input {...field} id="email" aria-invalid={fieldState.invalid} placeholder="Correo electrónico" autoComplete="on" />
                {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
              </Field>
            )}
          />

          <Controller
            control={form.control}
            name="password"
            rules={{
              required: {
                value: true,
                message: 'La contraseña es obligatoria.',
              },
            }}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid}>
                <FieldLabel data-invalid={fieldState.invalid} htmlFor="password">
                  Contraseña
                </FieldLabel>
                <Input {...field} id="password" aria-invalid={fieldState.invalid} type="password" placeholder="Contraseña" autoComplete="new-password" />
                {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
              </Field>
            )}
          />

          <Controller
            control={form.control}
            name="password2"
            rules={{
              required: {
                value: true,
                message: 'La confirmación de contraseña es obligatoria.',
              },
              validate: value =>
                value === form.getValues('password') || 'La contraseña no coincide.',
            }}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid}>
                <FieldLabel data-invalid={fieldState.invalid} htmlFor="password2">
                  Confirmar contraseña
                </FieldLabel>
                <Input {...field} id="password2" aria-invalid={fieldState.invalid} type="password" placeholder="Confirmar contraseña" autoComplete="new-password" />
                {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
              </Field>
            )}
          />

          <div className={`col-12 ${styles['terminos']}`}>
            <a href={process.env.REACT_APP_PRIVACIDAD} target="_blank" rel="noopener noreferrer">
              Leer Aviso de Privacidad.
            </a>
            <button type="button" className="btn btn-link" onClick={toggleTerminos}>
              <FontAwesomeIcon icon={terminos ? faCheckSquare : faSquare} />
              <span>He leído y acepto el Aviso de Privacidad</span>
            </button>
          </div>
        </div>

        <button type="submit" disabled={!terminos} className={`btn btn-une ${styles['btn-submit']}`}>
          Registrarse
        </button>
      </form>
    </div>
  );
};

FormRegister.propTypes = {
  onAfterSubmit: PropTypes.func,
  alert: PropTypes.func,
};

FormRegister.defaultProps = {
  onAfterSubmit: f => f,
  alert: f => f,
};

export default reduxConnect(
  () => ({}),
  dispatch => ({
    alert: alert => dispatch(actions.alert(alert)),
  }),
)(FormRegister);
